import api from './api';

// Register a new user
const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  
  if (response.data.success) {
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user', JSON.stringify(response.data.user));
  }
  
  return response;
};

// Login user
const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  
  if (response.data.success) {
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user', JSON.stringify(response.data.user));
  }
  
  return response;
};

// Logout user
const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// Get current user
const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Check if user is authenticated
const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

// Get user profile from API
const getUserProfile = async () => {
  const response = await api.get('/auth/me');
  return response;
};

const authService = {
  register,
  login,
  logout,
  getCurrentUser,
  isAuthenticated,
  getUserProfile
};

export default authService;
